import React, { useEffect } from "react";
import { connect } from "react-redux";

import store from "glassRedux/store";

import MainItemsList from "features/itemLists/MainListView/MainItemsList";
import { fetchDoneList } from "shared/itemLists/redux/itemListsSlice";

function DoneItemsContainer(props) {
  useEffect(() => {
    store.dispatch(fetchDoneList());
  }, []);
  return (
    <MainItemsList {...props} listType={"Done"} mainItems={props.doneItems} />
  );
}

function mapStateToProps(state) {
  return {
    doneItems: state.itemLists.doneItems,
  };
}

export default connect(mapStateToProps)(DoneItemsContainer);
